export default __webpack_public_path__ + "static/assign-agent-details-b9b1dc55f6388c424ebe572f7329c46f.png";